export const tourReportName = {
  bsgReport: 'Ball, Shoe, Glove Report',
  tourBagReport: 'Tour Bag Report',
  tourPlayerReport: 'Tour Player Report',
  marketingReport: 'Marketing Report',
  contractReport: 'Contracts Report',
  contractHistoryReport: 'Contract History Report',
  transferClubReport: 'Transfer Club Report',
} as const;
